import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';

// Third-Party
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'; // ngx-bootstrap modules
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MomentModule } from 'angular2-moment';
import { MyDatePickerModule } from 'mydatepicker';

// Reports
import { ReportArchiveComponent } from '../components/archive-list/report-archive-list.component';
import { ReportComponent } from '../components/report/report.component';
import { ReportDownloadComponent } from '../components/download/report-download.component';
import { ReportListComponent } from '../components/report-list/report-list.component';
import { ReportNewComponent } from '../components/create/report-new.component';
import { ReportSummaryComponent } from '../components/summary/report-summary.component';
import { ReportStatusComponent } from '../components/status/report-status.component';
import { ReportViewComponent } from '../components/view/report-view.component';
import { SaveReportComponent } from '../components/save/report-save.component';
import { SimpleReportListComponent } from 'app/dashboard/components/recent-reports/list/simple-report-list.component';
import { SimpleReportListItemComponent } from 'app/dashboard/components/recent-reports/item/simple-report-list-item.component';

// Adjustments
import { AdjustmentComponent } from '../adjustments/components/adjustment.component';
import { SectorAdjustmentsComponent } from '../adjustments/components/sector-adjustments.component';
import { SpecificationAdjustmentsComponent } from '../adjustments/components/specification-adjustments.component';
import { VehicleAdjustmentsComponent } from '../adjustments/components/vehicle-adjustments.component';
import { ViewAdjustmentsModalComponent } from 'app/report/adjustments/components/view-adjustments.modal.component';

// Services
import { ReportManagementService } from '../services/report-management.service';
import { ReportCreationService } from '../services/report-creation.service';
import { ReportDownloadService } from '../services/report-download.service';
import { ReportService } from '../services/report.service';

// Modules
import { AppRoutingModule } from 'app/routing/modules/routing.module';
import { SharedModule } from 'app/shared/modules/shared.module';
import { BsModalService } from 'ngx-bootstrap/modal/bs-modal.service';

@NgModule({
    declarations: [
        AdjustmentComponent,
        ReportArchiveComponent,
        ReportComponent,
        ReportDownloadComponent,
        ReportListComponent,
        ReportNewComponent,
        ReportSummaryComponent,
        ReportStatusComponent,
        ReportViewComponent,
        SaveReportComponent,
        SectorAdjustmentsComponent,
        VehicleAdjustmentsComponent,
        SimpleReportListComponent,
        SimpleReportListItemComponent,
        SpecificationAdjustmentsComponent,
        ViewAdjustmentsModalComponent
    ],
    imports: [
        AppRoutingModule,
        BsDropdownModule.forRoot(),
        ModalModule,
        CollapseModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        MomentModule,
        MyDatePickerModule,
        ReactiveFormsModule,
        SharedModule
    ],
    exports: [
        SimpleReportListComponent,
    ],
    providers: [
        ReportService,
        ReportCreationService,
        ReportManagementService,
        ReportDownloadService,
        HttpClientModule,
        BsModalService
    ],
    entryComponents: [ ViewAdjustmentsModalComponent ]
})

export class ReportModule { }



// WEBPACK FOOTER //
// ./src/app/report/modules/report.module.ts